import React, { createContext, ReactNode, useContext, useState } from 'react'
import { Backdrop } from '../components/Backdrop'

type ModalContextValues = {
  showBackdrop: () => void
  closeBackdrop: () => void
}

export type ModalContent = {}

type BackdropProviderProps = {
  children: ReactNode
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const BackdropModalContext = createContext({} as ModalContextValues)

const BackdropModalProvider = ({ children }: BackdropProviderProps) => {
  const [loading, setLoading] = useState(false)
  const showBackdrop = () => {
    setLoading(true)
  }

  const closeBackdrop = () => {
    setLoading(false)
  }

  return (
    <BackdropModalContext.Provider value={{ showBackdrop, closeBackdrop }}>
      {children}
      <Backdrop loading={loading} close={showBackdrop} />
    </BackdropModalContext.Provider>
  )
}

const useBackdropModalContext = () => {
  return useContext(BackdropModalContext)
}

export { useBackdropModalContext, BackdropModalProvider }
